import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import ServiceDetail from "../views/ServiceDetail";	

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'building-construction' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServiceDetail/>
		} else if(
			appContext.navSubItem === 'civil-engineering' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServiceDetail/>
		} else if(
			appContext.navSubItem === 'rehabilitation' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServiceDetail/>
		} else if(
			appContext.navSubItem === 'maintenance' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServiceDetail/>
		} 
			return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}